<template>
  <SimpleComparisonRow
    :label="$t('generic.audience_score')"
    no-padding-top
    :data="data"
    :number-products="numberProducts"
    :index="index"
    :no-highlight="$parent.noHighlight"
  >
    <template v-slot="{ columnData }">
      <div class="similar-comparison-data-body">
        <CoreScore
          :score="columnData.value?.score"
          :text="columnData.value?.score_text"
          :color="columnData.value?.score_color"
          :explainer-bars="facts.scoreDistribution"
          :users-score="columnData.value?.users_score"
          :users-votes-count="columnData.value?.users_votes_count"
          :expert-review-score="columnData.value?.expert_score"
          :expert-reviews-count="columnData.value?.expert_reviews_count"
          :category="categoryGroups.currentCategory"
        />
      </div>
    </template>
  </SimpleComparisonRow>
</template>

<script setup>
import SimpleComparisonRow from '@/components/shared/simple-comparison/SimpleComparisonRow';
// import SimpleComparisonCoreScoreRowPopover from '@/components/shared/simple-comparison/SimpleComparisonCoreScoreRowPopover';
// import HelpCircledIcon from '@/components/icons/awesome-font/HelpCircledIcon';
import CoreScore from '~/components/shared/product/CoreScore';
import { useFactsStore } from "~/stores/facts";
import { useCategoryGroupsStore } from "~/stores/categoryGroups";

const props = defineProps({
  data: {
    type: Object,
    required: true,
  },
  numberProducts: {
    type: Number,
    default: 3,
  },
  index: {
    type: Number,
    default: 0,
  },
  scoresSmall: {
    type: Boolean,
    default: false,
  },
})

const facts = useFactsStore();
const categoryGroups = useCategoryGroupsStore();
</script>

<style lang="scss" scoped>
.similar-comparison-data-header {
  #comparison-corescore-explainer {
    cursor: pointer;
  }
}
.similar-comparison-data-body {
  :deep(.corescore) {
    font-size: 1.4rem;
    .corescore__score {
      font-size: inherit;
      line-height: 16px;
      padding: 3px;
    }
    .corescore__text {
      font-size: inherit;
    }
  }
}
</style>
